import { createSlice } from "@reduxjs/toolkit";

import { clearStore } from "actions/initialization";

const initialState = {
  playing: false,
  currentSrc: null,
  loadingHash: {},
  place: undefined,
};

const tinyPlayerSlice = createSlice({
  name: "tinyPlayer",
  initialState,
  reducers: {
    tinyPlayerPlay(state, action) {
      const { src, place } = action.payload || {};
      if (state.currentSrc !== src) state.loadingHash[src] = !!src;
      state.currentSrc = src;
      state.playing = !!src;
      state.place = place;
    },
    tinyPlayerPause(state, action) {
      const { playing } = action.payload;
      state.playing = playing;
      state.loadingHash[state.currentSrc] = false;
    },
    tinyPlayerLoading(state, action) {
      const loading = action.payload;
      state.loadingHash[state.currentSrc] = loading;
    },
  },
  extraReducers: (builder) => builder.addCase(clearStore, () => initialState),
});

export const actions = tinyPlayerSlice.actions;

export default tinyPlayerSlice.reducer;
